import React from 'react';
import { motion } from 'framer-motion';
import './ui.css';

interface AlertProps {
  variant?: 'error' | 'success';
  children: React.ReactNode;
  className?: string;
}

const Alert: React.FC<AlertProps> = ({ variant = 'error', children, className = '' }) => (
  <motion.div
    className={`ui-alert ui-alert--${variant} ${className}`}
    role={variant === 'error' ? 'alert' : 'status'}
    aria-live="polite"
    initial={{ opacity: 0, y: -6 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -6 }}
    transition={{ duration: 0.2 }}
  >
    {children}
  </motion.div>
);

export default Alert;
